export default "__VITE_ASSET__J4941_Kk__"